// extracted by mini-css-extract-plugin
export default {"resultsContainer":"O5_2t_1quxTP7Fu1pwAA","categoryHeader":"sZUmTsHfH1ll_2Of1Q0P","categoryIconContainer":"ZvRkFkJpW4kH30zxouCx","categoryIcon":"p7yi_jqMhgc_cO9i5syQ"};